// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"345":"429030a3ab59a28b93ab","724":"9a3a7646c83fcdbf7bd4","856":"d0ce80e7f65ead03f801"}[chunkId] + ".js";
};